
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-filing-cabinet",
      function () {
        return require("private-next-pages/digital-filing-cabinet.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-filing-cabinet"])
      });
    }
  